import isSubSet from '~/utils/isSubSet.ts';

const isSubSetArray = <T>(array: T[], subSetArray: T[]) => {
  return isSubSet(new Set(array), new Set(subSetArray));
};
export default isSubSetArray;
